// Message length counter
(() => {
	/** @type {HTMLTextAreaElement} */
	const messageTextArea = document.getElementById("message");

	/** @type {HTMLSpanElement} */
	const messageLengthSpan = document.getElementById("message-length");

	messageLengthSpan.textContent = `${messageTextArea.textLength}/${messageTextArea.maxLength}`;
	messageTextArea.addEventListener("input", () => {
		messageLengthSpan.textContent = `${messageTextArea.textLength}/${messageTextArea.maxLength}`;
	});
})();

// Fill redirect URL
(() => {
	const redirectUrl = new URL("./success/", document.location).href;

	/** @type {HTMLInputElement} */
	const redirectEl = document.getElementById("redirect");
	redirectEl.value = redirectUrl;
})();



let isCaptchaSolved = false;


// Determine whether the submit button should be enabled or disabled.
function adjustFormSubmitButton() {
	const submitButton = document.querySelector("#contact-form input[type='submit']");

	/** @type {HTMLInputElement} */
	const nameInput = document.getElementById("name");

	/** @type {HTMLInputElement} */
	const emailInput = document.getElementById("email");

	/** @type {HTMLInputElement} */
	const subjectInput = document.getElementById("subject");

	/** @type {HTMLTextAreaElement} */
	const messageTextarea = document.getElementById("message");


	const enable = [
		nameInput.value.length > 0,
		emailInput.value.length > 0,
		subjectInput.value.length > 0,
		messageTextarea.textLength > 0,
		isCaptchaSolved,
	].every(condition => condition === true);

	if (enable) {
		submitButton.removeAttribute("disabled");
	} else {
		submitButton.setAttribute("disabled", "");
	}
}


// Check whether to enable the submit button
// every time the form is updated.
(() => {
	/** @type {HTMLInputElement} */
	const nameInput = document.getElementById("name");

	/** @type {HTMLInputElement} */
	const emailInput = document.getElementById("email");

	/** @type {HTMLInputElement} */
	const subjectInput = document.getElementById("subject");

	/** @type {HTMLTextAreaElement} */
	const messageTextarea = document.getElementById("message");


	nameInput.addEventListener("input", adjustFormSubmitButton);
	emailInput.addEventListener("input", adjustFormSubmitButton);
	subjectInput.addEventListener("input", adjustFormSubmitButton);
	messageTextarea.addEventListener("input", adjustFormSubmitButton);
})();


// Callbacks
function onHCaptchaSuccessful() {
	isCaptchaSolved = true;
	adjustFormSubmitButton();
}